import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useTranslation from "next-translate/useTranslation";

const NoDataFound = ({
  title = "No data found",
  description = "There is nothing to display here.",
  variant = "default", // small, default, large
  icon,
}) => {
  const { t } = useTranslation("common");

  if (variant === "large") {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={4}
        color="text.secondary"
      >
        <Box mb={1}>{icon || <InfoOutlinedIcon fontSize="large" />}</Box>

        <Typography variant="subtitle1">{t(title)}</Typography>

        {description && <Typography variant="body2">{t(description)}</Typography>}
      </Box>
    );
  }

  if (variant === "small") {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        py={0}
        color="text.secondary"
      >
        <Box mb={1}>{icon || <InfoOutlinedIcon fontSize="small" />}</Box>

        <Typography variant="subtitle2">{t(title)}</Typography>

        {description && <Typography variant="caption">{t(description)}</Typography>}
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      py={2}
      color="text.secondary"
    >
      <Box mb={1}>{icon || <InfoOutlinedIcon fontSize="medium" />}</Box>

      <Typography variant="subtitle1">{t(title)}</Typography>

      {description && <Typography variant="body2">{t(description)}</Typography>}
    </Box>
  );
};

export default NoDataFound;
